/**
 * MeetingRecurrenceService
 * Service for MeetingRecurrence entity operations
 * Route: api/meetingrecurrences
 * Controller: MeetingRecurrencesController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * MeetingRecurrenceService
 * Handles meeting recurrence CRUD operations and the materialisation sweep
 * Maps to /api/meetingrecurrences endpoint
 */
export class MeetingRecurrenceService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? MeetingRecurrenceService.DEFAULT_SERVICE_PATH,
            basePath: MeetingRecurrenceService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CUSTOM METHODS ====================
    /**
     * Get all recurrences for a meeting
     * GET /api/meetingrecurrences/GetByMeeting/{meetingId}
     * @param meetingId - Meeting ID
     * @returns Array of meeting recurrences
     */
    async getByMeeting(meetingId) {
        const response = await this.getByMeetingRaw(meetingId);
        return response.data ?? [];
    }
    getByMeetingRaw(meetingId) {
        const url = this.buildUrl('GetByMeeting/' + meetingId);
        return this.http.get(url);
    }
    /**
     * Materialise a recurrence — expand its RRULE into child meeting occurrences forward to the
     * rolling 90-day horizon. Returns the number of occurrences created.
     * POST /api/meetingrecurrences/materialize/{id}
     * @param id - Recurrence ID
     * @returns The number of occurrences created
     */
    async materialize(id) {
        const response = await this.materializeRaw(id);
        return response.data ?? 0;
    }
    materializeRaw(id) {
        const url = this.buildUrl('materialize/' + id);
        return this.http.post(url, {});
    }
}
MeetingRecurrenceService.DEFAULT_SERVICE_PATH = 'meetings';
MeetingRecurrenceService.BASE_PATH = 'api/meetingrecurrences';
//# sourceMappingURL=MeetingRecurrenceService.js.map